import { render, staticRenderFns } from "./group-list-wrapper.vue?vue&type=template&id=56b93184"
import script from "./group-list-wrapper.vue?vue&type=script&lang=js"
export * from "./group-list-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56b93184')) {
      api.createRecord('56b93184', component.options)
    } else {
      api.reload('56b93184', component.options)
    }
    module.hot.accept("./group-list-wrapper.vue?vue&type=template&id=56b93184", function () {
      api.rerender('56b93184', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/shared/security-group/user-binding/group-list-wrapper.vue"
export default component.exports